// Location helpers. mapLinkFor must stay identical to the backend placeholder {OrtKartenlink}
// (https://www.google.com/maps/search/?api=1&query={lat},{lng}, coordinates invariant "0.######").

// Fallback map center when no location exists yet: Spielfeld Bad Wildbad.
export const DEFAULT_MAP_CENTER = [48.734889, 8.542888];

// Backend limits (Location.Name max 200, Location.Address max 500).
export const LOCATION_NAME_MAX = 200;
export const LOCATION_ADDRESS_MAX = 500;

// Coordinates are stored as decimal(9,6) -> round to 6 decimals before sending.
export const roundCoord = (value) => Math.round(Number(value) * 1e6) / 1e6;

export const isValidLatLng = (lat, lng) => {
  const la = Number(lat);
  const ln = Number(lng);
  return lat != null && lng != null
    && Number.isFinite(la) && Number.isFinite(ln)
    && la >= -90 && la <= 90 && ln >= -180 && ln <= 180;
};

// Mirrors C# ToString("0.######", InvariantCulture): max. 6 decimals, no trailing zeros, dot separator.
export function formatCoord(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  const rounded = Number(n.toFixed(6));
  return String(Object.is(rounded, -0) ? 0 : rounded);
}

export function mapLinkFor(location) {
  if (!location || !isValidLatLng(location.latitude, location.longitude)) return null;
  return `https://www.google.com/maps/search/?api=1&query=${formatCoord(location.latitude)},${formatCoord(location.longitude)}`;
}

export const sortLocationsByName = (list) =>
  [...list].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '', 'de', { sensitivity: 'base' }));
